export default __webpack_public_path__ + "static/media/23.1b0d1f7d.jpeg";